import { Button, Checkbox, FormControlLabel, FormGroup, Grid, Link, Radio, Switch, Typography } from '@mui/material';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Fieldset } from '../../../../../../shared/ui/form/fieldset/FieldsetContainer';
import { useSecondStageVm } from './useSecondStage.vm';
import { DateInput } from '../../../../../../shared/ui/form/date/Date';
import { SelectCustom } from '../../../../../../shared/ui/form/select/Select';
import {
  currentCushingSpecializationOptions,
  currentRecognitionAdrenalCushingSyndromeOptions,
  currentRecognitionEtopicACTHProductionSyndromeOptions,
  macroAdenomaKnospScaleOptions,
  otherMethodsTkArrayCheckboxesConfig
} from './SecondStage.helper';
import { InputController } from '../../../../../../shared/ui/form/inputController/InputController';
import { IInputControllerSecondStage } from './SecondStage.types';
import { MarkersLabel, RadioExtraContainer, RadioGroupStyled } from './SecondStage.styled';
import { Input } from '../../../../../../shared/ui/form/input/Input';
import { ButtonsActions } from '../../common/buttonsActions/ButtonsActions';
import { radioValueOptional } from '../../../CaseDraft.helper';
import { CheckboxesGroup } from '../../../../../../shared/ui/form/checkboxesGroup/CheckboxesGroup';
import { FileUploadLayout } from '../../../../../../shared/fileUploadLayer/FileUploadLayer';
import { Label } from '../../../../../../shared/ui/form/label/Label';
import { Add } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom';

export const SecondStage = observer(() => {
  const {
    formik,
    activeFieldset,
    handleSave,
    handleResetFieldset,
    handleDraftSave,
    handleChangeSwitchAndCheckbox,
    adenomaFieldsActive,
    setActiveBroadcast,
    inputControllerElements,
    setActive,
    handleChangeArray,
    setFileHandler,
    addOtherMethod
  } = useSecondStageVm();

  const params = useParams();

  const isCushing = params && params?.type?.includes('cushing') && params?.version?.includes('v2');
  const imageOpener = (link: string) => {
    window.open(link, '_blank');
  };

  return (
    <Grid container justifyContent={'space-between'}>
      <Fieldset legend={'Aktualne rozpoznanie'}>
        <Grid container>
          <Grid item xs={12} display={'flex'} alignItems={'center'} justifyContent={'center'} mt={2}>
            <RadioGroupStyled row={true} name={'currentDiagnosisCushing'} value={formik.values.currentDiagnosisCushing}>
              <FormControlLabel
                onChange={formik.handleChange}
                value={'choroba Cushinga'}
                style={{ marginBottom: 8 }}
                control={
                  <Radio
                    checked={formik.values.currentDiagnosisCushing === 'choroba Cushinga'}
                    onClick={() =>
                      formik.setFieldValue(
                        'currentDiagnosisCushing',
                        radioValueOptional(formik.values.currentDiagnosisCushing, 'choroba Cushinga')
                      )
                    }
                  />
                }
                label="choroba Cushinga"
              />
              <InputController<IInputControllerSecondStage>
                setBroadcast={setActiveBroadcast}
                broadcastFields={['currentDiagnosisProductionACTHCheck', 'currentDiagnosisAdrenalCushingCheck']}
                active={formik.values.currentDiagnosisCushing === 'zespół ektopowej produkcji ACTH'}
                setField={formik.setFieldValue}
                radioProvider={true}
                isHalf={true}
                radio={{
                  name: 'currentDiagnosisCushing',
                  label: 'zespół ektopowej produkcji ACTH'
                }}
                inputName={'currentDiagnosisCushing'}
              >
                <SelectCustom
                  disabled={formik.values.currentDiagnosisCushing !== 'zespół ektopowej produkcji ACTH'}
                  error={Boolean(formik.errors.currentDiagnosisProductionACTHCheck)}
                  name={'currentDiagnosisProductionACTHCheck'}
                  placeholder={'Wybierz'}
                  label={'Wybierz'}
                  onChange={formik.handleChange}
                  value={formik.values.currentDiagnosisProductionACTHCheck}
                  options={currentRecognitionEtopicACTHProductionSyndromeOptions}
                />
              </InputController>
              {formik.values.currentDiagnosisProductionACTHCheck === 'Inny' && (
                <Grid xs={12} item my={1}>
                  <Input
                    InputLabelProps={{ shrink: true }}
                    fullWidth={true}
                    required={true}
                    label={'Inny'}
                    name={'currentDiagnosisProductionACTHOther'}
                    type={'text'}
                    onChange={formik.handleChange}
                    value={formik.values.currentDiagnosisProductionACTHOther}
                  />
                </Grid>
              )}
              <InputController<IInputControllerSecondStage>
                setBroadcast={setActiveBroadcast}
                broadcastFields={['currentDiagnosisProductionACTHCheck', 'currentDiagnosisAdrenalCushingCheck']}
                active={formik.values.currentDiagnosisCushing === 'zespół Cushinga pochodzenia nadnerczowego'}
                setField={formik.setFieldValue}
                radioProvider={true}
                isHalf={true}
                radio={{
                  name: 'currentDiagnosisCushing',
                  label: 'zespół Cushinga pochodzenia nadnerczowego'
                }}
                inputName={'currentDiagnosisCushing'}
              >
                <SelectCustom
                  disabled={formik.values.currentDiagnosisCushing !== 'zespół Cushinga pochodzenia nadnerczowego'}
                  error={Boolean(formik.errors.currentDiagnosisAdrenalCushingCheck)}
                  name={'currentDiagnosisAdrenalCushingCheck'}
                  placeholder={'Wybierz'}
                  label={'Wybierz'}
                  onChange={formik.handleChange}
                  value={formik.values.currentDiagnosisAdrenalCushingCheck}
                  options={currentRecognitionAdrenalCushingSyndromeOptions}
                />
              </InputController>
              <FormControlLabel
                value={'ACTH-zależny zespół Cushinga o nieustalonej etiologii'}
                control={
                  <Radio
                    checked={
                      formik.values.currentDiagnosisCushing === 'ACTH-zależny zespół Cushinga o nieustalonej etiologii'
                    }
                    onClick={() =>
                      formik.setFieldValue(
                        'currentDiagnosisCushing',
                        radioValueOptional(
                          formik.values.currentDiagnosisCushing,
                          'ACTH-zależny zespół Cushinga o nieustalonej etiologii'
                        )
                      )
                    }
                  />
                }
                label="ACTH-zależny zespół Cushinga o nieustalonej etiologii"
              />
            </RadioGroupStyled>
          </Grid>
        </Grid>
      </Fieldset>
      <Fieldset
        activeKey={activeFieldset}
        keyFieldset={'valid-fieldset-1'}
        legend={'Kto rozpoznał zespół Cushinga'}
        handleReset={handleResetFieldset}
      >
        <Grid container mt={2}>
          <Grid item xs={5} pr={2}>
            <SelectCustom
              error={Boolean(formik.errors.courseWhoRecognized)}
              name={'courseWhoRecognized'}
              placeholder={'Kto rozpoznał - specjalizacja'}
              label={'Kto rozpoznał / specjalizacja'}
              onChange={formik.handleChange}
              value={formik.values.courseWhoRecognized}
              options={currentCushingSpecializationOptions}
            />
          </Grid>
          <Grid item xs={4} pr={2}>
            <DateInput
              label={'Data rozpoznania'}
              required={false}
              views={['year', 'month']}
              openTo={'year'}
              name={'courseDateStart'}
              inputFormat={'mm.yyyy'}
              value={formik.values.courseDateStart}
              error={Boolean(formik.errors.courseDateStart)}
              onBlur={() => formik.setFieldTouched('courseDateStart', true)}
              onChange={e => formik.setFieldValue('courseDateStart', e)}
            />
          </Grid>
        </Grid>
      </Fieldset>

      <Fieldset legend={'Badania hormonalne w okresie ustalania rozpoznania'}>
        <Grid container>
          <Grid
            item
            xs={12}
            pt={2}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <InputController<IInputControllerSecondStage>
              setActive={setActive}
              active={inputControllerElements.hormonalTestDuringTheDiagnosisCortisol}
              setField={formik.setFieldValue}
              isHalf={true}
              checkbox={{
                name: 'hormonalTestDuringTheDiagnosisCortisolCheckbox',
                label: 'kortyzol w surowicy w godzinach porannych'
              }}
              inputName={'hormonalTestDuringTheDiagnosisCortisol'}
            >
              <Input
                InputLabelProps={{ shrink: true }}
                disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisCortisol}
                name={'hormonalTestDuringTheDiagnosisCortisol'}
                type={'text'}
                error={Boolean(formik.errors.hormonalTestDuringTheDiagnosisCortisol) && formik.touched.hormonalTestDuringTheDiagnosisCortisol}
                onChange={formik.handleChange}
                value={formik.values.hormonalTestDuringTheDiagnosisCortisol}
                label={'(μg/dL)'}
              />
            </InputController>
          </Grid>
          <Grid
            item
            xs={12}
            pt={2}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <InputController<IInputControllerSecondStage>
              setActive={setActive}
              active={inputControllerElements.hormonalTestDuringTheDiagnosisCortisolEvening}
              setField={formik.setFieldValue}
              isHalf={true}
              checkbox={{
                name: 'hormonalTestDuringTheDiagnosisCortisolEveningCheckbox',
                label: 'kortyzol w surowicy w godzinach późnowieczornych'
              }}
              inputName={'hormonalTestDuringTheDiagnosisCortisolEvening'}
            >
              <Input
                InputLabelProps={{ shrink: true }}
                disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisCortisolEvening}
                name={'hormonalTestDuringTheDiagnosisCortisolEvening'}
                type={'text'}
                error={Boolean(formik.errors.hormonalTestDuringTheDiagnosisCortisolEvening) && formik.touched.hormonalTestDuringTheDiagnosisCortisolEvening}
                onChange={formik.handleChange}
                value={formik.values.hormonalTestDuringTheDiagnosisCortisolEvening}
                label={'(μg/dL)'}
              />
            </InputController>
          </Grid>
          <Grid
            item
            xs={12}
            pt={2}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <InputController<IInputControllerSecondStage>
              setActive={setActive}
              active={inputControllerElements.hormonalTestDuringTheDiagnosisCortisolDeks}
              setField={formik.setFieldValue}
              isHalf={true}
              checkbox={{
                name: 'hormonalTestDuringTheDiagnosisCortisolDeksCheckbox',
                label: 'kortyzol w surowicy w teście z 1 mg deksametazonu'
              }}
              inputName={'hormonalTestDuringTheDiagnosisCortisolDeks'}
            >
              <Input
                error={Boolean(formik.errors.hormonalTestDuringTheDiagnosisCortisolDeks) && formik.touched.hormonalTestDuringTheDiagnosisCortisolDeks}
                InputLabelProps={{ shrink: true }}
                disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisCortisolDeks}
                name={'hormonalTestDuringTheDiagnosisCortisolDeks'}
                type={'text'}
                onChange={formik.handleChange}
                value={formik.values.hormonalTestDuringTheDiagnosisCortisolDeks}
                label={'(μg/dL)'}
              />
            </InputController>
          </Grid>
          <Grid
            item
            xs={12}
            pt={1}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <InputController<IInputControllerSecondStage>
              setActive={setActive}
              active={inputControllerElements.hormonalTestDuringTheDiagnosisACTH}
              setField={formik.setFieldValue}
              isHalf={true}
              checkbox={{
                name: 'hormonalTestDuringTheDiagnosisACTHCheckbox',
                label: 'ACTH w osoczu w godzinach porannych'
              }}
              inputName={'hormonalTestDuringTheDiagnosisACTH'}
            >
              <Input
                error={Boolean(formik.errors.hormonalTestDuringTheDiagnosisACTH) && formik.touched.hormonalTestDuringTheDiagnosisACTH}
                InputLabelProps={{ shrink: true }}
                disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisACTH}
                name={'hormonalTestDuringTheDiagnosisACTH'}
                type={'text'}
                onChange={formik.handleChange}
                value={formik.values.hormonalTestDuringTheDiagnosisACTH}
                label={'(pg/ml)'}
              />
            </InputController>
          </Grid>
          <Grid
            item
            xs={12}
            pt={1}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <InputController<IInputControllerSecondStage>
              setActive={setActive}
              active={inputControllerElements.hormonalTestDuringTheDiagnosisFreeCortisol}
              setField={formik.setFieldValue}
              isHalf={true}
              checkbox={{
                name: 'hormonalTestDuringTheDiagnosisFreeCortisolCheckbox',
                label: 'mUFC (wolny kortyzol w moczu, optymalnie średnia z dwóch lub trzech DZM)'
              }}
              inputName={'hormonalTestDuringTheDiagnosisFreeCortisol'}
            >
              <Input
                error={Boolean(formik.errors.hormonalTestDuringTheDiagnosisFreeCortisol) && formik.touched.hormonalTestDuringTheDiagnosisFreeCortisol}
                InputLabelProps={{ shrink: true }}
                disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisFreeCortisol}
                name={'hormonalTestDuringTheDiagnosisFreeCortisol'}
                type={'text'}
                onChange={formik.handleChange}
                value={formik.values.hormonalTestDuringTheDiagnosisFreeCortisol}
                label={'(μg/dobę)'}
              />
            </InputController>
          </Grid>
          <Grid
            item
            xs={12}
            pt={1}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <InputController<IInputControllerSecondStage>
              setActive={setActive}
              active={inputControllerElements.hormonalTestDuringTheDiagnosisMLNSC}
              setField={formik.setFieldValue}
              isHalf={true}
              checkbox={{
                name: 'hormonalTestDuringTheDiagnosisMLNSCCheckbox',
                label: 'mLNSC (kortyzol w ślinie w godzinach późnowieczornych, optymalnie średnia z dwóch oznaczeń)'
              }}
              inputName={'hormonalTestDuringTheDiagnosisMLNSC'}
            >
              <Input
                error={Boolean(formik.errors.hormonalTestDuringTheDiagnosisMLNSC) && formik.touched.hormonalTestDuringTheDiagnosisMLNSC}
                InputLabelProps={{ shrink: true }}
                disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisMLNSC}
                name={'hormonalTestDuringTheDiagnosisMLNSC'}
                type={'text'}
                onChange={formik.handleChange}
                value={formik.values.hormonalTestDuringTheDiagnosisMLNSC}
                label={'(nmol/L)'}
              />
            </InputController>
          </Grid>
          <Grid
            item
            xs={12}
            pt={1}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <InputController<IInputControllerSecondStage>
              setActive={setActive}
              active={inputControllerElements.hormonalTestDuringTheDiagnosisCRH}
              setField={formik.setFieldValue}
              isHalf={true}
              checkbox={{
                name: 'hormonalTestDuringTheDiagnosisCRHCheckbox',
                label: 'test z CRH'
              }}
              inputName={'hormonalTestDuringTheDiagnosisCRH'}
            >
              <RadioGroupStyled
                error={Boolean(formik.errors.hormonalTestDuringTheDiagnosisCRH) &&
                  formik.touched.hormonalTestDuringTheDiagnosisCRH}
                row={true}
                name={'hormonalTestDuringTheDiagnosisCRH'}
                value={formik.values.hormonalTestDuringTheDiagnosisCRH}
              >
                <FormControlLabel
                  disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisCRH}
                  onChange={formik.handleChange}
                  value={'pozytywny'}
                  control={<Radio />}
                  label="pozytywny"
                />
                <FormControlLabel
                  disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisCRH}
                  onChange={formik.handleChange}
                  value={'negatywny'}
                  control={<Radio />}
                  label="negatywny"
                />
              </RadioGroupStyled>
            </InputController>
          </Grid>
          <Grid
            item
            xs={12}
            pt={1}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <InputController<IInputControllerSecondStage>
              setActive={setActive}
              active={inputControllerElements.hormonalTestDuringTheDiagnosisDesmopressin}
              setField={formik.setFieldValue}
              isHalf={true}
              checkbox={{
                name: 'hormonalTestDuringTheDiagnosisDesmopressinCheckbox',
                label: 'test z desmopresyną'
              }}
              inputName={'hormonalTestDuringTheDiagnosisDesmopressin'}
            >
              <RadioGroupStyled
                error={Boolean(formik.errors.hormonalTestDuringTheDiagnosisDesmopressin) &&
                  formik.touched.hormonalTestDuringTheDiagnosisDesmopressin}
                row={true}
                name={'hormonalTestDuringTheDiagnosisDesmopressin'}
                value={formik.values.hormonalTestDuringTheDiagnosisDesmopressin}
              >
                <FormControlLabel
                  disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisDesmopressin}
                  onChange={formik.handleChange}
                  value={'pozytywny'}
                  control={<Radio />}
                  label="pozytywny"
                />
                <FormControlLabel
                  disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisDesmopressin}
                  onChange={formik.handleChange}
                  value={'negatywny'}
                  control={<Radio />}
                  label="negatywny"
                />
              </RadioGroupStyled>
            </InputController>
          </Grid>

          <Grid
            item
            xs={12}
            pt={1}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'center'}
          >
            <InputController<IInputControllerSecondStage>
              setActive={setActive}
              active={inputControllerElements.hormonalTestDuringTheDiagnosisDexamethasone}
              setField={formik.setFieldValue}
              isHalf={true}
              checkbox={{
                name: 'hormonalTestDuringTheDiagnosisDexamethasoneCheckbox',
                label: 'test z „wysoką” dawką deksametazonu'
              }}
              inputName={'hormonalTestDuringTheDiagnosisDexamethasone'}
            >

              <RadioGroupStyled
                error={Boolean(formik.errors.hormonalTestDuringTheDiagnosisDexamethasone) &&
                  formik.touched.hormonalTestDuringTheDiagnosisDexamethasone}
                row={true}
                name={'hormonalTestDuringTheDiagnosisDexamethasone'}
                value={formik.values.hormonalTestDuringTheDiagnosisDexamethasone}
              >
                <FormControlLabel

                  disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisDexamethasone}
                  onChange={formik.handleChange}
                  value={'pozytywny'}
                  control={<Radio />}
                  label="pozytywny"
                />
                <FormControlLabel
                  disabled={!inputControllerElements.hormonalTestDuringTheDiagnosisDexamethasone}
                  onChange={formik.handleChange}
                  value={'negatywny'}
                  control={<Radio />}
                  label="negatywny"
                />
              </RadioGroupStyled>
            </InputController>
          </Grid>
        </Grid>
      </Fieldset>
      <Fieldset legend={'Wynik obrazowania układu podwzgórzowo-przysadkowego w MR/TK'}>
        <Grid container>
          <Grid item xs={12} pt={4} display={'flex'} flexDirection={'row'} justifyContent={'flex-start'}>
            <RadioGroupStyled
              row={false}
              name={'imagingResultMrTkMacroMicroadenoma'}
              value={formik.values.imagingResultMrTkMacroMicroadenoma}
            >
              <FormControlLabel
                onChange={formik.handleChange}
                value={'obraz prawidłowy'}
                control={
                  <Radio
                    onClick={() =>
                      formik.setFieldValue(
                        'imagingResultMrTkMacroMicroadenoma',
                        radioValueOptional(formik.values.imagingResultMrTkMacroMicroadenoma, 'obraz prawidłowy')
                      )
                    }
                  />
                }
                label="obraz prawidłowy"
              />
              <FormControlLabel
                onChange={formik.handleChange}
                value={'mikrogruczolak'}
                control={
                  <Radio
                    onClick={() =>
                      formik.setFieldValue(
                        'imagingResultMrTkMacroMicroadenoma',
                        radioValueOptional(formik.values.imagingResultMrTkMacroMicroadenoma, 'mikrogruczolak')
                      )
                    }
                  />
                }
                label="mikrogruczolak"
              />
              <RadioExtraContainer>
                <FormControlLabel
                  onChange={formik.handleChange}
                  value={'makrogruczolak'}
                  control={
                    <Radio
                      onClick={() =>
                        formik.setFieldValue(
                          'imagingResultMrTkMacroMicroadenoma',
                          radioValueOptional(formik.values.imagingResultMrTkMacroMicroadenoma, 'makrogruczolak')
                        )
                      }
                    />
                  }
                  label="makrogruczolak"
                />
                {adenomaFieldsActive && (
                  <RadioGroupStyled
                    row={true}
                    name={'imagingResultMrTkMacroadenomaInfiltration'}
                    value={formik.values.imagingResultMrTkMacroadenomaInfiltration}
                  >
                    <FormControlLabel
                      onChange={async e => {
                        formik.handleChange(e);
                      }}
                      value={'ucisk skrzyżowania wzrokowego'}
                      control={
                        <Radio
                          checked={
                            formik.values.imagingResultMrTkMacroadenomaInfiltration === 'ucisk skrzyżowania wzrokowego'
                          }
                        />
                      }
                      label="ucisk skrzyżowania wzrokowego"
                    />

                    <Grid width={'100%'} container display={'flex'} alignItems={'flex-start'} flexWrap={'nowrap'}>
                      <FormControlLabel
                        onChange={formik.handleChange}
                        value={'naciekanie zatok jamistych'}
                        control={<Radio />}
                        label="naciekanie zatok jamistych"
                      />
                      <Grid flexGrow={1}>
                        <InputController<IInputControllerSecondStage>
                          setActive={setActive}
                          active={inputControllerElements.infiltrationScaleRight}
                          setField={formik.setFieldValue}
                          checkbox={{
                            name: 'infiltrationRightActive',
                            isActive: formik.values.infiltrationRightActive,
                            label: 'Prawa zatoka',
                            disabled:
                              formik.values.imagingResultMrTkMacroadenomaInfiltration !== 'naciekanie zatok jamistych'
                          }}
                          inputName={'infiltrationScaleRight'}
                        >
                          <SelectCustom
                            disabled={!inputControllerElements.infiltrationScaleRight}
                            error={Boolean(formik.errors.infiltrationScaleRight)}
                            name={'infiltrationScaleRight'}
                            placeholder={'Stopień w skali Knospa'}
                            label={'Stopień w skali Knospa'}
                            onChange={formik.handleChange}
                            value={formik.values.infiltrationScaleRight}
                            options={macroAdenomaKnospScaleOptions}
                          />
                        </InputController>
                        <Grid item mt={1}>
                          <InputController<IInputControllerSecondStage>
                            setActive={setActive}
                            active={inputControllerElements.infiltrationScaleLeft}
                            setField={formik.setFieldValue}
                            checkbox={{
                              name: 'infiltrationLeftActive',
                              isActive: formik.values.infiltrationLeftActive,
                              label: 'Lewa zatoka',
                              disabled:
                                formik.values.imagingResultMrTkMacroadenomaInfiltration !== 'naciekanie zatok jamistych'
                            }}
                            inputName={'infiltrationScaleLeft'}
                          >
                            <SelectCustom
                              disabled={!inputControllerElements.infiltrationScaleLeft}
                              error={Boolean(formik.errors.infiltrationScaleLeft)}
                              name={'infiltrationScaleLeft'}
                              placeholder={'Stopień w skali Knospa'}
                              label={'Stopień w skali Knospa'}
                              onChange={formik.handleChange}
                              value={formik.values.infiltrationScaleLeft}
                              options={macroAdenomaKnospScaleOptions}
                            />
                          </InputController>
                        </Grid>
                      </Grid>
                    </Grid>
                  </RadioGroupStyled>
                )}
              </RadioExtraContainer>
              <RadioExtraContainer>
                <FormControlLabel
                  onChange={formik.handleChange}
                  value={'inne'}
                  control={
                    <Radio
                      onClick={() =>
                        formik.setFieldValue(
                          'imagingResultMrTkMacroMicroadenoma',
                          radioValueOptional(formik.values.imagingResultMrTkMacroMicroadenoma, 'inne')
                        )
                      }
                    />
                  }
                  label="inne"
                />
                {formik.values.imagingResultMrTkMacroMicroadenoma === 'inne' && (
                  <Grid xs={12} item width="100%">
                    <Input
                      InputLabelProps={{ shrink: true }}
                      fullWidth={true}
                      name={'imagingResultMrTkOther'}
                      type={'text'}
                      onChange={formik.handleChange}
                      value={formik.values.imagingResultMrTkOther}
                      label={'Inne'}
                    />
                  </Grid>
                )}
              </RadioExtraContainer>
            </RadioGroupStyled>
          </Grid>
        </Grid>
      </Fieldset>
      <Fieldset legend={'Inne metody obrazowania'}>
        <Grid container>
          <Grid item xs={12} mt={1} display="flex" flexWrap="nowrap">
            <FormControlLabel
              control={
                <Checkbox
                  name={'otherMethodsTkActive'}
                  checked={formik.values.otherMethodsTkActive}
                  onChange={async e => {
                    formik.handleChange(e);
                    if (!e.target.checked) {
                      await formik.setFieldValue('otherMethodsTkArray', []);
                      await formik.setFieldValue('otherMethodsTkDescription', '');
                      await formik.setFieldValue('otherMethodsTkFiles', null);
                    }
                  }}
                />
              }
              label="TK"
            />
            <CheckboxesGroup
              name={'otherMethodsTkArray'}
              elements={[
                ...otherMethodsTkArrayCheckboxesConfig.map(el => ({
                  ...el,
                  disabled: !formik.values.otherMethodsTkActive
                }))
              ]}
              onChange={handleChangeArray}
              values={formik.values.otherMethodsTkArray}
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <Input
              InputLabelProps={{ shrink: true }}
              disabled={!formik.values.otherMethodsTkActive}
              fullWidth={true}
              name={'otherMethodsTkDescription'}
              label={'Opis TK'}
              type={'text'}
              rows={5}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.otherMethodsTkDescription}
              error={Boolean(formik.errors.otherMethodsTkDescription)}
              multiline={true}
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <Label>Załącznik:</Label>
            <FileUploadLayout
              htmlFor={'otherMethodsTkFiles'}
              setFileHandler={(file: File | null) => setFileHandler('otherMethodsTkFiles', file)}
              maxFileSize={3}
              extensions={['png', 'jpg', 'pdf']}
              fileType={['image', 'pdf']}
            />
          </Grid>

          {formik.values.otherMethodsTkFiles?.link && (
            <Grid mt={4} item xs={12} mb={1} sx={{ wordBreak: 'break-all' }}>
              <Grid item xs={12} display="flex" gap={2} alignItems={'center'}>
                <Link href={formik.values.otherMethodsTkFiles?.link} target={'_blank'} rel="noreferrer">
                  {formik.values.otherMethodsTkFiles?.name || formik.values.otherMethodsTkFiles?.link}
                </Link>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  color={'primary'}
                  onClick={() => setFileHandler('otherMethodsTkFiles', null)}
                />
              </Grid>
              {formik.values.otherMethodsTkFiles?.type?.includes('image') && (
                <Grid item maxHeight="152px" xs={3} pl={1} pr={1} pt={2} height="152px" overflow={'hidden'}>
                  <img
                    onClick={() => imageOpener(formik.values.otherMethodsTkFiles?.link!)}
                    src={formik.values.otherMethodsTkFiles?.link}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      cursor: 'pointer'
                    }}
                    alt=""
                  />
                </Grid>
              )}
            </Grid>
          )}

          <Grid item xs={12} mt={1} display="flex" flexWrap="nowrap">
            <FormControlLabel
              control={
                <Checkbox
                  name={'otherMethodsSomatostatinActive'}
                  checked={formik.values.otherMethodsSomatostatinActive}
                  onChange={async e => {
                    formik.handleChange(e);
                    if (!e.target.checked) {
                      await formik.setFieldValue('otherMethodsSomatostatinResult', '');
                      await formik.setFieldValue('otherMethodsSomatostatinFiles', null);
                    }
                  }}
                />
              }
              label="scyntygrafia receptorów somatostatynowych"
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <Input
              InputLabelProps={{ shrink: true }}
              disabled={!formik.values.otherMethodsSomatostatinActive}
              fullWidth={true}
              name={'otherMethodsSomatostatinResult'}
              label={'Wynik'}
              type={'text'}
              rows={5}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.otherMethodsSomatostatinResult}
              error={Boolean(formik.errors.otherMethodsSomatostatinResult)}
              multiline={true}
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <Label>Załącznik:</Label>
            <FileUploadLayout
              htmlFor={'otherMethodsSomatostatinFiles'}
              setFileHandler={(file: File | null) => setFileHandler('otherMethodsSomatostatinFiles', file)}
              maxFileSize={3}
              extensions={['png', 'jpg', 'pdf']}
              fileType={['image', 'pdf']}
            />
          </Grid>

          {formik.values.otherMethodsSomatostatinFiles?.link && (
            <Grid mt={4} item xs={12} mb={1} sx={{ wordBreak: 'break-all' }}>
              <Grid item xs={12} display="flex" gap={2} alignItems={'center'}>
                <Link
                  href={
                    formik.values.otherMethodsSomatostatinFileslink || formik.values.otherMethodsSomatostatinFiles?.link
                  }
                  target={'_blank'}
                  rel="noreferrer"
                >
                  {formik.values.otherMethodsSomatostatinFiles?.name ||
                    formik.values.otherMethodsSomatostatinFiles?.link}
                </Link>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  color={'primary'}
                  onClick={() => setFileHandler('otherMethodsSomatostatinFiles', null)}
                />
              </Grid>

              {formik.values.otherMethodsSomatostatinFiles?.type?.includes('image') && (
                <Grid item maxHeight="152px" xs={3} pl={1} pr={1} pt={2} height="152px" overflow={'hidden'}>
                  <img
                    onClick={() => imageOpener(formik.values.otherMethodsSomatostatinFiles?.link!)}
                    src={formik.values.otherMethodsSomatostatinFiles?.link}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      cursor: 'pointer'
                    }}
                    alt=""
                  />
                </Grid>
              )}
            </Grid>
          )}
          <Grid item xs={12} mt={1} display="flex" flexWrap="nowrap">
            <FormControlLabel
              control={
                <Checkbox
                  name={'otherMethods68PETActive'}
                  checked={formik.values.otherMethods68PETActive}
                  onChange={async e => {
                    formik.handleChange(e);
                    if (!e.target.checked) {
                      await formik.setFieldValue('otherMethods68PETResult', '');
                      await formik.setFieldValue('otherMethods68PETFiles', null);
                    }
                  }}
                />
              }
              label="68Ga-DOTATATE PET CT"
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <Input
              InputLabelProps={{ shrink: true }}
              disabled={!formik.values.otherMethods68PETActive}
              fullWidth={true}
              name={'otherMethods68PETResult'}
              label={'Wynik'}
              type={'text'}
              rows={5}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.otherMethods68PETResult}
              error={Boolean(formik.errors.otherMethods68PETResult)}
              multiline={true}
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <Label>Załącznik:</Label>
            <FileUploadLayout
              htmlFor={'otherMethods68PETFiles'}
              setFileHandler={(file: File | null) => setFileHandler('otherMethods68PETFiles', file)}
              maxFileSize={3}
              extensions={['png', 'jpg', 'pdf']}
              fileType={['image', 'pdf']}
            />
          </Grid>
          {formik.values.otherMethods68PETFiles?.link && (
            <Grid mt={4} item xs={12} mb={1} sx={{ wordBreak: 'break-all' }}>
              <Grid item xs={12} display="flex" gap={2} alignItems={'center'}>
                <Link href={formik.values.otherMethods68PETFiles?.link} target={'_blank'} rel="noreferrer">
                  {formik.values.otherMethods68PETFiles?.name || formik.values.otherMethods68PETFiles?.link}
                </Link>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  color={'primary'}
                  onClick={() => setFileHandler('otherMethods68PETFiles', null)}
                />
              </Grid>
              {formik.values.otherMethods68PETFiles?.type?.includes('image') && (
                <Grid item maxHeight="152px" xs={3} pl={1} pr={1} pt={2} height="152px" overflow={'hidden'}>
                  <img
                    onClick={() => imageOpener(formik.values.otherMethods68PETFiles?.link!)}
                    src={formik.values.otherMethods68PETFiles?.link}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      cursor: 'pointer'
                    }}
                    alt=""
                  />
                </Grid>
              )}
            </Grid>
          )}
          <Grid item xs={12} mt={1} display="flex" flexWrap="nowrap">
            <FormControlLabel
              control={
                <Checkbox
                  name={'otherMethods18PETActive'}
                  checked={formik.values.otherMethods18PETActive}
                  onChange={async e => {
                    formik.handleChange(e);
                    if (!e.target.checked) {
                      await formik.setFieldValue('otherMethods18PETResult', '');
                      await formik.setFieldValue('otherMethods18PETFiles', null);
                    }
                  }}
                />
              }
              label="18F-FDG PET CT"
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <Input
              InputLabelProps={{ shrink: true }}
              disabled={!formik.values.otherMethods18PETActive}
              fullWidth={true}
              name={'otherMethods18PETResult'}
              label={'Wynik'}
              type={'text'}
              rows={5}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.otherMethods18PETResult}
              error={Boolean(formik.errors.otherMethods18PETResult)}
              multiline={true}
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <Label>Załącznik:</Label>
            <FileUploadLayout
              htmlFor={'otherMethods18PETFiles'}
              setFileHandler={(file: File | null) => setFileHandler('otherMethods18PETFiles', file)}
              maxFileSize={3}
              extensions={['png', 'jpg', 'pdf']}
              fileType={['image', 'pdf']}
            />
          </Grid>
          {formik.values.otherMethods18PETFiles?.link && (
            <Grid mt={4} item xs={12} mb={1} sx={{ wordBreak: 'break-all' }}>
              <Grid item xs={12} display="flex" gap={2} alignItems={'center'}>
                <Link href={formik.values.otherMethods18PETFiles?.link} target={'_blank'} rel="noreferrer">
                  {formik.values.otherMethods18PETFiles?.name || formik.values.otherMethods18PETFiles?.link}
                </Link>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  color={'primary'}
                  onClick={() => setFileHandler('otherMethods18PETFiles', null)}
                />
              </Grid>
              {formik.values.otherMethods18PETFiles?.type?.includes('image') && (
                <Grid item maxHeight="152px" xs={3} pl={1} pr={1} pt={2} height="152px" overflow={'hidden'}>
                  <img
                    onClick={() => imageOpener(formik.values.otherMethods18PETFiles?.link!)}
                    src={formik.values.otherMethods18PETFiles?.link}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      cursor: 'pointer'
                    }}
                    alt=""
                  />
                </Grid>
              )}
            </Grid>
          )}
          <Grid item xs={12} mt={1} display="flex" flexWrap="nowrap">
            <FormControlLabel
              control={
                <Checkbox
                  name={'otherMethodsOtherActive'}
                  checked={formik.values.otherMethodsOtherActive}
                  onChange={formik.handleChange}
                />
              }
              label="inne"
            />
          </Grid>
          <Grid item xs={12}>
            {formik.values.otherMethodsOtherArray?.length > 0 &&
              formik.values.otherMethodsOtherArray.map((el, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={12} mt={2} display={'flex'} gap={2} alignItems={'center'}>
                    <Typography color={'text-primary'} variant={'body1'}>
                      {index + 1}
                    </Typography>

                    <Input
                      InputLabelProps={{ shrink: true }}
                      disabled={!formik.values.otherMethodsOtherActive}
                      fullWidth={true}
                      name={`otherMethodsOtherArray[${index}]otherMethod`}
                      label={'Inna metoda obrazowania'}
                      type={'text'}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.otherMethodsOtherArray[index].otherMethod}
                      error={Boolean(formik.errors.otherMethodsOtherArray)}
                      multiline={true}
                    />
                  </Grid>
                  <Grid item xs={12} mt={2}>
                    <Label>Załącznik:</Label>
                    <FileUploadLayout
                      htmlFor={`otherMethodsOtherArray[${index}]otherMethodFiles`}
                      setFileHandler={(file: File | null) => setFileHandler(`otherMethodsOtherArray`, file, index)}
                      maxFileSize={3}
                      extensions={['png', 'jpg', 'pdf']}
                      fileType={['image', 'pdf']}
                    />
                  </Grid>

                  {formik.values.otherMethodsOtherArray?.length > 0 &&
                    formik.values.otherMethodsOtherArray[index].otherMethodFiles?.link && (
                      <Grid mt={4} item xs={12} mb={1} sx={{ wordBreak: 'break-all' }}>
                        <Grid item xs={12} display="flex" gap={2} alignItems={'center'}>
                          <Link
                            href={formik.values.otherMethodsOtherArray[index]?.otherMethodFiles?.link}
                            target={'_blank'}
                            rel="noreferrer"
                          >
                            {formik.values.otherMethodsOtherArray[index].otherMethodFiles?.name ||
                              formik.values.otherMethodsOtherArray[index].otherMethodFiles?.link}
                          </Link>
                          <CloseIcon
                            sx={{ cursor: 'pointer' }}
                            color={'primary'}
                            onClick={() => setFileHandler(`otherMethodsOtherArray`, null, index)}
                          />
                        </Grid>
                        {formik.values.otherMethodsOtherArray &&
                          formik.values.otherMethodsOtherArray[index].otherMethodFiles?.type?.includes('image') && (
                            <Grid item maxHeight="152px" xs={3} pl={1} pr={1} pt={2} height="152px" overflow={'hidden'}>
                              <img
                                onClick={() =>
                                  imageOpener(formik.values.otherMethodsOtherArray[index]?.otherMethodFiles?.link!)
                                }
                                src={formik.values.otherMethodsOtherArray[index]?.otherMethodFiles?.link}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                  cursor: 'pointer'
                                }}
                                alt=""
                              />
                            </Grid>
                          )}
                      </Grid>
                    )}
                </React.Fragment>
              ))}
          </Grid>
          <Button
            sx={{ marginTop: 1 }}
            startIcon={<Add />}
            onClick={addOtherMethod}
            size={'large'}
            color={'primary'}
            variant={'contained'}
          >
            Dodaj
          </Button>
        </Grid>
      </Fieldset>

      {(formik.values.currentDiagnosisCushing === 'choroba Cushinga' ||
        formik.values.currentDiagnosisCushing === 'zespół ektopowej produkcji ACTH') && (
          <Fieldset legend={'Badanie histopatologiczne'}>
            <Grid container>
              {formik.values.currentDiagnosisCushing === 'choroba Cushinga' && (
                <>
                  <Grid
                    item
                    xs={12}
                    pt={4}
                    display={'flex'}
                    flexDirection={'column'}
                    alignItems={'flex-start'}
                    justifyContent={'center'}
                  >
                    <FormGroup>
                      <Label>Choroba Cushinga:</Label>
                      <FormControlLabel
                        onChange={formik.handleChange}
                        value={'potwierdzenie immunohistochemiczne guza kortykotropowego w materiale tkankowym'}
                        name={'confirmationOfSomatotropicTissueMaterial'}
                        control={
                          <Switch
                            checked={Boolean(formik.values.confirmationOfSomatotropicTissueMaterial)}
                            onChange={event =>
                              handleChangeSwitchAndCheckbox(
                                'confirmationOfSomatotropicTissueMaterial',
                                event.target.checked
                              )
                            }
                          />
                        }
                        label="potwierdzenie immunohistochemiczne guza kortykotropowego w materiale tkankowym"
                      />
                    </FormGroup>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    pt={1}
                    display={'flex'}
                    flexDirection={'column'}
                    alignItems={'flex-start'}
                    justifyContent={'center'}
                  >
                    <RadioGroupStyled
                      row={true}
                      name={'proliferationMarkerKi67'}
                      value={formik.values.proliferationMarkerKi67}
                    >
                      <MarkersLabel>MARKERY PROLIFERACJI Ki-67</MarkersLabel>
                      <FormControlLabel
                        onChange={formik.handleChange}
                        value={'< 3%'}
                        control={
                          <Radio
                            onClick={() =>
                              formik.setFieldValue(
                                'proliferationMarkerKi67',
                                radioValueOptional(formik.values.proliferationMarkerKi67, '< 3%')
                              )
                            }
                          />
                        }
                        label="< 3%"
                      />
                      <FormControlLabel
                        onChange={formik.handleChange}
                        value={'≥ 3%'}
                        control={
                          <Radio
                            onClick={() =>
                              formik.setFieldValue(
                                'proliferationMarkerKi67',
                                radioValueOptional(formik.values.proliferationMarkerKi67, '≥ 3%')
                              )
                            }
                          />
                        }
                        label="≥ 3%"
                      />
                    </RadioGroupStyled>
                  </Grid>
                  <Grid item xs={12} mt={4}>
                    <Label>Badanie w mikroskopie elektronowym</Label>
                  </Grid>
                  <RadioGroupStyled
                    row={true}
                    name={'electronMicroscopicExamination'}
                    value={formik.values.electronMicroscopicExamination}
                  >
                    <FormControlLabel
                      onChange={formik.handleChange}
                      value={'SG-ACTH'}
                      control={
                        <Radio
                          onClick={() =>
                            formik.setFieldValue(
                              'electronMicroscopicExamination',
                              radioValueOptional(formik.values.electronMicroscopicExamination, 'SG-ACTH')
                            )
                          }
                        />
                      }
                      label="SG-ACTH"
                    />
                    <FormControlLabel
                      onChange={formik.handleChange}
                      value={'DG-ACTH'}
                      control={
                        <Radio
                          onClick={() =>
                            formik.setFieldValue(
                              'electronMicroscopicExamination',
                              radioValueOptional(formik.values.electronMicroscopicExamination, 'DG-ACTH')
                            )
                          }
                        />
                      }
                      label="DG-ACTH"
                    />
                    <FormControlLabel
                      onChange={formik.handleChange}
                      value={'Crook Cell adenoma'}
                      control={
                        <Radio
                          onClick={() =>
                            formik.setFieldValue(
                              'electronMicroscopicExamination',
                              radioValueOptional(formik.values.electronMicroscopicExamination, 'Crook Cell adenoma')
                            )
                          }
                        />
                      }
                      label="Crook Cell adenoma"
                    />
                  </RadioGroupStyled>
                </>
              )}

              {formik.values.currentDiagnosisCushing === 'zespół ektopowej produkcji ACTH' && (
                <>
                  <Grid item xs={12} mb={2} mt={4}>
                    <Label>Zespół ektopowej produkcji ACTH:</Label>
                  </Grid>
                  <Grid item xs={2} mb={2}>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      label={'Ki-67'}
                      name={'pancreaticNeuroendocrineTumor'}
                      type={'text'}
                      onChange={formik.handleChange}
                      value={formik.values.pancreaticNeuroendocrineTumor}
                    />
                  </Grid>
                  <Input
                    InputLabelProps={{ shrink: true }}
                    fullWidth={true}
                    label={'Inne markery nowotworowe'}
                    name={'otherPancreaticNeuroendocrineTumor'}
                    type={'text'}
                    onChange={formik.handleChange}
                    value={formik.values.otherPancreaticNeuroendocrineTumor}
                  />
                  <Grid item xs={12} mb={2} mt={4}>
                    <Label>ACTH-niezależny zespół Cushinga:</Label>
                  </Grid>
                  <Input
                    InputLabelProps={{ shrink: true }}
                    fullWidth={true}
                    label={'Rozpoznanie histopatologiczne'}
                    name={'acthIndependentCushingSyndrome'}
                    type={'text'}
                    rows={5}
                    multiline
                    onChange={formik.handleChange}
                    value={formik.values.acthIndependentCushingSyndrome}
                  />
                </>
              )}
            </Grid>
          </Fieldset>
        )}
      {isCushing && (
        <Grid item xs={12} display={'flex'} justifyContent={'flex-end'} mt={2}>
          <Typography variant="caption" color={'rgba(0,0,0,0.6)'}>
            PL-IST-0068
          </Typography>
        </Grid>
      )}
      <ButtonsActions handleDraftSave={handleDraftSave} handleSave={handleSave} />
    </Grid>
  );
});
